module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Wow!")]), _vm._v(" you think to yourself. "), _c('i', [_vm._v("This black man talking to me is so articulate!")]), _vm._v(" You mean it as a compliment. ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You can keep that to yourself. That black man is the judge in your DUI trial. Maybe let your lawyer do the talking.")]), _vm._v(" "), _c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c69be92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap6.vue
// module id = 87
// module chunks = 0